<template>
  <a-modal
    :visible="visible"
    :title="modalTitle"
    :footer="false"
    width="30%"
    @cancel="onClose"
  >
    <div>
      <div class="">
        <label>{{ $t("actualite.trimester_one") }}</label>
      </div>
      <div class="">
        <a-select
          size="large"
          v-model="trimesterSource"
          :placeholder="$t('paiement.selectionnerMois')"
          style="width: 100%; height: 100%"
          class="pb-2 p-2"
        >
          <a-select-option
            v-for="trimester in ['1', '2', '3']"
            :key="trimester"
            :value="trimester"
          >
            {{ trimester }}
          </a-select-option>
        </a-select>
      </div>
    </div>

    <div>
      <div class="">
        <label>{{ $t("actualite.trimester_two") }}</label>
      </div>
      <div class="">
        <a-select
          size="large"
          v-model="trimesterDestination"
          :placeholder="$t('paiement.selectionnerMois')"
          style="width: 100%; height: 100%"
          class="pb-2 p-2"
        >
          <a-select-option
            v-for="trimester in ['1', '2', '3']"
            :key="trimester"
            :value="trimester"
          >
            {{ trimester }}
          </a-select-option>
        </a-select>
      </div>
    </div>

    <div class="form-actions mt-0">
      <a-button
        type="primary"
        :loading="loading"
        class="mr-3"
        @click="cloneByTrimester()"
      >
        {{ $t("action.clone") }}
      </a-button>
      <a-button :style="{ marginRight: '8px' }" @click="onClose">
        {{ $t("action.annuler") }}
      </a-button>
    </div>
  </a-modal>
</template>
<script>
import apiClient from "@/services/axios";
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    selectedTeacher: {
      type: String,
      default: null,
    },
    selectedTrimester: {
      type: String,
      default: "1",
    },
  },
  data() {
    return {
      loading: false,
      trimesterSource: "1",
      trimesterDestination: "2",
    };
  },
  computed: {
    modalTitle() {
      return !this.selectedTeacher
        ? this.$t("enseignant.duplicateAccessForAllTeachers")
        : this.$t("enseignant.duplicateAccessForTeacher");
    },
  },
  methods: {
    onClose() {
      this.$emit("close");
    },
    async cloneByTrimester() {
      this.loading = true;
      const url =
        "/teacherAccess/clone/" +
        this.trimesterSource +
        "/" +
        this.trimesterDestination;
      const config = this.selectedTeacher
        ? { params: { teacherId: this.selectedTeacher } }
        : {};
      try {
        await apiClient.put(url, null, config);
        this.$message.success(
          this.$t("enseignant.accessLevelAddedSuccessfully")
        );
        this.$emit("reload");
        this.$emit("close");
      } catch (err) {
        this.$message.error(this.$t("enseignant.accessLevelNotAdded"));
        console.log(err);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
